/**
 * Form field wrapper — label above input.
 * Renders children (input/select/textarea) untouched so callers keep full control.
 */
export function NexaField({ label, hint, error, children, className = "" }) {
  return (
    <div className={className}>
      {label && <label className="lux-label">{label}</label>}
      {children}
      {hint && !error && <div className="mt-1.5 text-[11.5px] text-nexa-mute">{hint}</div>}
      {error && <div className="mt-1.5 text-[11.5px] text-nexa-danger">{error}</div>}
    </div>
  );
}
